import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

interface State {
	isMobile: boolean;
	isOpen: boolean;
}

const initialState: State = { isMobile: false, isOpen: true };

export const AppDataStore = signalStore(
	{ providedIn: 'root' },
	withState(initialState),
	withComputed((state) => ({ sideNavMode: computed(() => state.isMobile() ? 'over' : 'side') })),
	withMethods((state) => ({
		setIsMobile: (value: boolean) => patchState(state, { isMobile: value, isOpen: !value }),
		setIsOpen: (value: boolean) => patchState(state, { isOpen: value }),
		toggleIsOpen: () => patchState(state, { isOpen: !state.isOpen() })
	}))
);
